import {
    createReducer
} from 'helpers/ReducerUtil'
import {
    UPDATE_SCHEDULE
} from './constants'


const updateSchedule = (prev, action) => action.schedule 
const scheduleReducer = createReducer({}, {
    [UPDATE_SCHEDULE]: updateSchedule
})

export {
    scheduleReducer
}